import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Card, Form, Alert } from 'react-bootstrap';

function CoverTextSettingsControls({ job, token, onSaved }) {
    const [colorMode, setColorMode] = useState('color');
    const [verticalPosition, setVerticalPosition] = useState('top');
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        setColorMode(job?.cover_text_color_mode || 'color');
        setVerticalPosition(job?.cover_text_vertical_position || 'top');
    }, [job?.cover_text_color_mode, job?.cover_text_vertical_position]);

    const save = async () => {
        setSaving(true);
        setMessage('');
        setError('');
        try {
            const response = await fetch(`/api/genai/jobs/${job.job_id}/cover-text-settings/`, {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    cover_text_color_mode: colorMode,
                    cover_text_vertical_position: verticalPosition,
                }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Could not update cover text');
            setMessage('Cover text updated.');
            onSaved?.(data.job);
        } catch (saveError) {
            setError(saveError.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Card className="mb-4 border-secondary">
            <Card.Body>
                <Card.Title>Cover Text</Card.Title>
                <Form.Label>Color</Form.Label>
                <ButtonGroup className="w-100 mb-3">
                    <Button variant={colorMode === 'color' ? 'primary' : 'outline-primary'} onClick={() => setColorMode('color')}>Color</Button>
                    <Button variant={colorMode === 'black' ? 'primary' : 'outline-primary'} onClick={() => setColorMode('black')}>Black</Button>
                </ButtonGroup>
                <Form.Label>Position</Form.Label>
                <ButtonGroup className="w-100 mb-3">
                    <Button variant={verticalPosition === 'top' ? 'primary' : 'outline-primary'} onClick={() => setVerticalPosition('top')}>Top</Button>
                    <Button variant={verticalPosition === 'bottom' ? 'primary' : 'outline-primary'} onClick={() => setVerticalPosition('bottom')}>Bottom</Button>
                </ButtonGroup>
                {message && <Alert variant="success" className="py-2">{message}</Alert>}
                {error && <Alert variant="danger" className="py-2">{error}</Alert>}
                <Button onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save Cover Text'}</Button>
            </Card.Body>
        </Card>
    );
}

export default CoverTextSettingsControls;